 // mapping of year to EDSS scale values
 // 

 // year <-> bar array index [0..21]
 export default [
   0,
   3,
   10,
   4,
   12,
   6,
   6,
   11,
   9,
   9,
   9,
   12,
   10,
   11,
   11,
   12,
   12,
   12,
   13,
   14,
   15
 ];